import { APISortOrder, APISortOption } from '@scayle/storefront-core'

enum SortQuery {
  Topseller = 'topseller',
  DateNewest = 'date-newest',
  PriceDesc = 'price-desc',
  PriceAsc = 'price-asc',
}

enum SortName {
  Topseller = 'topseller',
  DateNewest = 'date_newest',
  PriceDesc = 'price_desc',
  PriceAsc = 'price_asc',
}

enum ProductStandardSorting {
  Price = 'price',
  DateAdded = 'new',
}

enum SortOrder {
  Ascending = 'asc',
  Descending = 'desc',
}

export interface SortValue {
  name: SortName
  query?: SortQuery
  by?: ProductStandardSorting
  direction?: SortOrder
}

export const sortingValues = {
  topSeller: {
    name: SortName.Topseller,
    direction: SortOrder.Ascending,
    sortingKey: 'default',
  },
  dateNewest: {
    by: ProductStandardSorting.DateAdded,
    name: SortName.DateNewest,
    query: SortQuery.DateNewest,
  },
  priceDesc: {
    by: ProductStandardSorting.Price,
    direction: SortOrder.Descending,
    name: SortName.PriceDesc,
    query: SortQuery.PriceDesc,
  },
  priceAsc: {
    by: ProductStandardSorting.Price,
    direction: SortOrder.Ascending,
    name: SortName.PriceAsc,
    query: SortQuery.PriceAsc,
  },
}

export type SortingValueKey = keyof typeof sortingValues

export const getSortByValue = (
  query: string,
  defaultSort?: SortingValueKey,
) => {
  switch (query) {
    case SortQuery.PriceDesc:
      return sortingValues.priceDesc
    case SortQuery.PriceAsc:
      return sortingValues.priceAsc
    case SortQuery.Topseller:
      return sortingValues.topSeller
    case SortQuery.DateNewest:
      return sortingValues.dateNewest
    default:
      return sortingValues[defaultSort || 'dateNewest']
  }
}
